import styled from 'styled-components';

export const OnboardingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 200px);
  background-color: ${({ theme }) => theme.colors.cardElevationLowWhite};
`;

export const HeaderStyled = styled.header<{ $hasBreadCrumbs: boolean; $hasTitle: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
  margin-bottom: ${({ $hasTitle }) => ($hasTitle ? '24px' : 0)};
  background: ${({ theme }) => theme.colors.cardElevationLowWhite};
`;

export const HeaderItemsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 16px;
`;
